module.exports = __webpack_public_path__ + "fonts/FilsonPro-Light.e9daff8.ttf";